import { PreoffersState } from './preoffers.types';

export const preloadedPreoffersState: PreoffersState = {
  preoffers: {
    isLoading: false,
    items: {},
    ids: [],
    totalPages: 0,
    totalElements: 0,
  },
};
